export default __webpack_public_path__ + "static/media/Kette.b503cb52.svg";